import { supabaseServer } from '@/lib/supabase.server';
import { createServerFn } from '@tanstack/react-start';

export const signOut = createServerFn().handler(async () => {
  const supabase = supabaseServer();
  const { error } = await supabase.auth.signOut();

  if (error) {
    return {
      error: true,
      message: error.message,
    }
  }
});